import React from 'react';
// Reuse Magic Upload's FilteredPills visuals verbatim so the active-filter pills
// (including the auto-applied "my requests" chip) and the Clear All control look and
// behave exactly like Magic Upload's filter pills.
import pillStyles from '../../../MagicUpload/components/FilteredPills/FilteredPills.module.scss';
import CrossIcon from '../../../../assets/Svg/CrossIcon';

export interface FilterPill {
    /** Filter key this pill belongs to (e.g. 'requestedBy', 'documentTypes') */
    key: string;
    /** The underlying filter value to remove */
    value: string;
    /** Human-readable label shown on the pill */
    label: string;
}

interface MagicSignFilterPillsProps {
    pills: FilterPill[];
    onRemove: (key: string, value: string) => void;
    onClearAll: () => void;
}

/**
 * Active-filter pills row for Magic Sign — mirrors Magic Upload's FilteredPills.
 * Each active filter value renders as a removable pill; a "Clear All" control
 * resets every filter (including the auto-applied user filter). The row collapses
 * to zero height when no filters are active (same transition as Magic Upload).
 */
const MagicSignFilterPills: React.FC<MagicSignFilterPillsProps> = ({ pills, onRemove, onClearAll }) => {
    const isEmpty = pills.length === 0;

    return (
        <div
            style={isEmpty ? { height: 0, padding: 0 } : { height: 'auto' }}
            className={pillStyles.FilteredPillsWrapper}
            data-testid="magic-sign-filter-pills"
        >
            {pills.map((p) => (
                <div key={`${p.key}:${p.value}`} className={pillStyles.Pill}>
                    <span>{p.label}</span>
                    <span className={pillStyles.CrossIcon} onClick={() => onRemove(p.key, p.value)}>
                        <CrossIcon colour={'var(--primary-text-colour)'} height="10" width="10" />
                    </span>
                </div>
            ))}
            <div style={isEmpty ? { height: 0 } : { height: 'auto' }} className={pillStyles.ClearAllPill} onClick={onClearAll}>
                <span>Clear All</span>
            </div>
        </div>
    );
};

export default MagicSignFilterPills;
